import { createFileRoute } from "@tanstack/react-router"
// import "@react-pdf-viewer/core/lib/styles/index.css"
// import "@react-pdf-viewer/default-layout/lib/styles/index.css"

// import { Worker } from "@react-pdf-viewer/core"
// import { PdfViewer } from "~/components/PDF/PdfViewer"
import CustomHead from "~/components/SEOHead/CustomHead"

function PdfTestPage() {
  return (
    <>
      <CustomHead />
      {/* <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.js">
        <div className="h-screen w-1/2">
          <PdfViewer />
        </div>
      </Worker> */}
    </>
  )
}

export const Route = createFileRoute("/pdf")({
  component: PdfTestPage,
})
